/* -----------------------------------------------------------------------------------------------------
  - Created: [31-01-2025] by [SREERAJ]
  - Modified: [YYYY-MM-DD] 
  - Description: This file contains custom table
  -------------------------------------------------------------------------------------------------------
*/

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import './CustomTableStyle.css'
import { Checkbox } from '@mui/material';
import { EllipsisWithTooltip } from '../CustomTooltip/EllipsisWithTooltip';
import { getRowHighlightStyle } from '../../../utils/constants';
import WarningAmberIcon from "@mui/icons-material/WarningAmber";

export default function CustomTable({ columns, rows, isCheckbox = false, selectedIds, handleSelectRow, handleSelectAll, isLoading }) {

    return (

        <TableContainer component={Paper} sx={{ boxShadow: 'none' }}>
            <Table aria-label="dynamic table">
                {/* ---------------- Table Header ---------------- */}
                <TableHead className="table-header">
                    <TableRow sx={{ border: 'none' }}>
                        {/* Render this column ONLY if at least one row has is_urgent  */}
                        {rows?.some((r) => r.is_urgent == true) && <TableCell sx={{ width: 50 }}></TableCell>}

                        {isCheckbox && (
                            <TableCell padding="checkbox">
                                <Checkbox
                                    checked={rows?.length > 0 && selectedIds?.length === rows?.length}
                                    indeterminate={selectedIds?.length > 0 && selectedIds?.length < rows?.length}
                                    onChange={(e) => handleSelectAll(e.target.checked)}
                                />
                            </TableCell>
                        )}

                        {columns?.map((column, colIndex) => (
                            <TableCell
                                key={colIndex}
                                className="table-cell"
                                align="start"
                                sx={{
                                    color: '#000000',
                                    border: 'none',
                                    fontWeight: 400,
                                    fontSize: '1rem',
                                    fontFamily: 'Inter',
                                }}
                            >
                                {column?.title}
                            </TableCell>
                        ))}
                    </TableRow>
                </TableHead>

                {/* ---------------- Table Body ---------------- */}
                <TableBody>
                    {rows?.length === 0 ? (
                        <TableRow sx={{ border: 'none' }}>
                            <TableCell
                                className="no-data-cell"
                                colSpan={
                                    columns.length +
                                    (isCheckbox ? 1 : 0) +
                                    (rows?.some((r) => r.is_urgent == true) ? 1 : 0)
                                }
                                sx={{
                                    textAlign: 'center',
                                    color: '#111827',
                                    border: 'none',
                                }}
                            >
                                {/* {isLoading ? `Loading...` : `No data available`} */}
                                {!isLoading && <span className="loader-text">No data available</span>}
                            </TableCell>
                        </TableRow>
                    ) : (
                        rows?.map((row, rowIndex) => (
                            <TableRow
                                key={rowIndex}
                                className={`table-row ${rowIndex % 2 === 0 ? 'even-row' : 'odd-row'}`}
                                sx={getRowHighlightStyle(row)}
                            >
                                {/* Urgent Icon Column (conditionally rendered) */}
                                {rows?.some((r) => r.is_urgent == true) && (
                                    <TableCell sx={{ border: 'none', width: 50 }}>
                                        {row.is_urgent == true && (
                                            <WarningAmberIcon sx={{ color: '#F57C00', fontSize: 20 }} />
                                        )}
                                    </TableCell>
                                )}

                                {/* Checkbox Column */}
                                {isCheckbox && (
                                    <TableCell padding="checkbox" sx={{ border: 'none' }}>
                                        {console.log("row",row)
                                        }
                                        {row?.hasOwnProperty('ScheduleStatus') ? (
                                            row.ScheduleStatus ? (
                                                <Checkbox
                                                    checked={selectedIds?.includes(row.id)}
                                                    onChange={() => handleSelectRow(row.id)}
                                                />
                                            ) : null
                                        ) : (
                                            <Checkbox
                                                checked={selectedIds?.includes(row.id)}
                                                onChange={() => handleSelectRow(row.id)}
                                            />
                                        )}
                                    </TableCell>
                                )}

                                {/* Data Columns */}
                                {columns?.map((column, colIndex) => (
                                    <TableCell
                                        key={colIndex}
                                        sx={{
                                            color: '#111827',
                                            border: 'none',
                                            fontWeight: 400,
                                            fontSize: '1rem',
                                            fontFamily: 'Inter',
                                            maxWidth: '250px',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            whiteSpace: 'nowrap',
                                            ...getRowHighlightStyle(row),
                                        }}
                                    >
                                        <EllipsisWithTooltip>
                                            {column.render
                                                ? column.render(row[column.key], row)
                                                : row[column.key] === 0
                                                    ? 0
                                                    : row[column.key] || '-'}
                                        </EllipsisWithTooltip>
                                    </TableCell>
                                ))}
                            </TableRow>
                        ))
                    )}
                </TableBody>
            </Table>
        </TableContainer>

        // <TableContainer component={Paper} sx={{ boxShadow: 'none' }}>
        //     {/* sx={{ minWidth: 650, borderCollapse: 'collapse' }}  */}
        //     <Table aria-label="dynamic table">
        //         {/* ---------------- Table Header ---------------- */}
        //         <TableHead className="table-header">
        //             <TableRow sx={{ border: 'none' }}>
        //                 {/*  Urgent Icon Column Header (empty for alignment) */}
        //                 {/* {isShowIcon && } */}
        //                 <TableCell></TableCell>
        //                 {isCheckbox && (
        //                     <TableCell padding="checkbox">
        //                         <Checkbox
        //                             checked={rows?.length > 0 && selectedIds?.length === rows?.length}
        //                             indeterminate={selectedIds?.length > 0 && selectedIds?.length < rows?.length}
        //                             onChange={(e) => handleSelectAll(e.target.checked)}
        //                         />
        //                     </TableCell>
        //                 )}

        //                 {columns?.map((column, colIndex) => (
        //                     <TableCell key={colIndex} className="table-cell" align="start" sx={{ color: '#000000', border: 'none', fontWeight: '400', fontSize: '1rem', fontFamily: 'Inter' }}>
        //                         {column?.title}
        //                     </TableCell>
        //                 ))}
        //             </TableRow>
        //         </TableHead>

        //         {/* ---------------- Table Body ---------------- */}
        //         <TableBody>
        //             {rows?.length === 0 ? (
        //                 <TableRow sx={{ border: 'none' }}>
        //                     <TableCell
        //                         className="no-data-cell"
        //                         colSpan={columns.length + (isCheckbox ? 1 : 0)}
        //                         sx={{
        //                             textAlign: 'center',
        //                             color: '#111827',
        //                             border: 'none',
        //                         }}
        //                     >
        //                         {isLoading ? `Loading...` : `No data available`}
        //                     </TableCell>
        //                 </TableRow>
        //             ) : (
        //                 rows?.map((row, rowIndex) => (
        //                     <TableRow
        //                         key={rowIndex}
        //                         className={`table-row ${rowIndex % 2 === 0 ? 'even-row' : 'odd-row'}`}
        //                         // className={`table-row ${rowIndex % 2 === 0 ? 'even-row' : 'even-row'} ${row.is_Schedule_Cancled === 1 ? 'cancelled-row' : ''}`}
        //                         sx={getRowHighlightStyle(row)}
        //                     >
        //                         <TableCell>
        //                             {row.is_urgent && (
        //                                 <WarningAmberIcon sx={{ color: "#F57C00", fontSize: 20 }} />
        //                             )}
        //                         </TableCell>

        //                         {isCheckbox && (
        //                             <TableCell padding="checkbox" sx={{ border: 'none' }}>
        //                                 {row?.hasOwnProperty("ScheduleStatus") ? (
        //                                     row.ScheduleStatus ? (
        //                                         <Checkbox
        //                                             checked={selectedIds?.includes(row.id)}
        //                                             onChange={() => handleSelectRow(row.id)}
        //                                         />
        //                                     ) : null // empty cell if ScheduleStatus is false
        //                                 ) : (
        //                                     <Checkbox
        //                                         checked={selectedIds?.includes(row.id)}
        //                                         onChange={() => handleSelectRow(row.id)}
        //                                     />
        //                                 )}
        //                             </TableCell>
        //                         )}

        //                         {columns?.map((column, colIndex) => (
        //                             <TableCell
        //                                 key={colIndex}
        //                                 sx={{
        //                                     color: '#111827',
        //                                     border: '',
        //                                     fontWeight: '400',
        //                                     fontSize: '1rem',
        //                                     fontFamily: 'Inter',
        //                                     maxWidth: '250px',
        //                                     overflow: 'hidden',
        //                                     textOverflow: 'ellipsis',
        //                                     whiteSpace: 'nowrap',
        //                                     ...getRowHighlightStyle(row)
        //                                 }}

        //                             >
        //                                 <EllipsisWithTooltip>

        //                                     {column.render
        //                                         ? column.render(row[column.key], row)
        //                                         : row[column.key] === 0
        //                                             ? 0
        //                                             : row[column.key] || '-'}
        //                                 </EllipsisWithTooltip>
        //                             </TableCell>

        //                         ))}


        //                     </TableRow>
        //                 ))
        //             )}
        //         </TableBody>


        //     </Table>
        // </TableContainer>


    );
}



